import { render, staticRenderFns } from "./GetAccessPopup.vue?vue&type=template&id=6af93e26&scoped=true"
import script from "./GetAccessPopup.vue?vue&type=script&lang=ts"
export * from "./GetAccessPopup.vue?vue&type=script&lang=ts"
import style0 from "./GetAccessPopup.vue?vue&type=style&index=0&id=6af93e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af93e26",
  null
  
)

export default component.exports